import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function Bicycle(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M12 4a1 1 0 011-1h1.534a2 2 0 011.893 1.355L18.352 10a5.5 5.5 0 11-1.993.352l-.732-2.146-5.242 4.411a5.5 5.5 0 11-1.342-1.485l.367-.308L5.586 7H5a1 1 0 010-2h3a1 1 0 01.35 1.937l2.596 2.595 3.989-3.357-.4-1.175H13a1 1 0 01-1-1zm-4.547 8.47a3.5 3.5 0 101.374 1.457l-2.183 1.838a1 1 0 01-1.288-1.53l2.097-1.765zm10.6 2.853l-1.048-3.076a3.501 3.501 0 102.057-.164l.884 2.594a1 1 0 01-1.893.646z",
    clipRule: "evenodd"
  }));
}

export default Bicycle;